module.exports = __webpack_public_path__ + "img/file-text.64ec75c1.svg";